<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<p class="tx53">
<a id="page25">
<b>104 </b>
<span class="st1">Use credit cards only for convenience, never for credit.</span>
</a></p><a id="page25">
<p class="tx53" id="p0025-01-1">
<b>105 </b>
<span class="st1">Treat yourself to a massage on your birthday.</span>
</p>
<p class="tx53" id="p0025-01-2">
<b>106 </b>
<span class="st1">Never cheat.</span>
</p>
<p class="tx53" id="p0025-01-3">
<b>107 </b>
<span class="st1">Smile a lot. It costs nothing and is beyond price.</span>
</p>
<p class="tx53" id="p0025-01-4">
<b>108 </b>
<span class="st1">Know how to drive a stick shift.</span>
</p>
<p class="tx53" id="p0025-01-5">
<b>109 </b>
<span class="st1">Spread crunchy peanut butter on Pepperidge Farm Gingerman cookies for the perfect late-night snack.</span>
</p>
<p class="tx53" id="p0025-01-6">
<b>110 </b>
<span class="st1">Never use profanity.</span>
</p>
</a><p class="tx53" id="p0026-P-1"><a id="page25">
<b>111 </b>
<span class="st1">
</span></a><a id="page26">When dining with clients or business associates, never order more than one cocktail or one glass of wine. If no one else is drinking, don’t drink at all.
 </a></p><a id="page26">
<p class="tx53" id="p0026-01-1">
<b>112 </b>
<span class="st1">Never argue with police officers, and address them as “officer.”</span>
</p>
<p class="tx53" id="p0026-01-2">
<b>113 </b>
<span class="st1">Learn to identify local wildflowers, birds, and trees.</span>
</p>
<p class="tx53" id="p0026-01-3">
<b>114 </b>
<span class="st1">Keep a fire extinguisher in your kitchen and car.</span>
</p>
<p class="tx53" id="p0026-01-4">
<b>115 </b>
<span class="st1">Give yourself a year and read the Bible cover to cover.</span>
</p>
<p class="tx53" id="p0026-01-5">
<b>116 </b>
<span class="st1">Consider writing a living will.</span>
</p>
</a><p class="tx53" id="p0027-P-1"><a id="page26">
</a><a id="page27">
<b>117 </b>
<span class="st1">Install dead bolt locks on outside doors.</span>
</a></p><a id="page27">
<p class="tx53" id="p0027-01-1">
<b>118 </b>
<span class="st1">Don’t buy expensive wine, luggage, or watches.</span>
</p>
<p class="tx53" id="p0027-01-2">
<b>119 </b>
<span class="st1">Put a lot of little marshmallows in your hot chocolate.</span>
</p>
<p class="tx53" id="p0027-01-3">
<b>120 </b>
<span class="st1">Learn CPR.</span>
</p>
<p class="tx53" id="p0027-01-4">
<b>121 </b>
<span class="st1">Resist the temptation to buy a boat. </span>
</p>
<p class="tx53" id="p0027-P-2">
<b>122 </b>
<span class="st1">Stop and read historical roadside markers.</span>
</p>
<p class="tx53" id="p0027-01-5">
<b>123 </b>
<span class="st1">Respect your children’s privacy. Knock before entering their room.</span>
</p>
</a></section><a id="page27">
</a></div>
<a id="page27">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter10.vue?020bc3ce